import { observer } from "mobx-react-lite";
import React, { useContext, useEffect } from "react";

import MoreDetailsBtn from "../components/MoreDetailsBtn";
import { ApiContext,NavigationContext } from "../contexts";
import { scrollToTop } from "../util";

const ThankYouScreen = observer(() => {
  const navContext = useContext(NavigationContext);
  const apiContext = useContext(ApiContext);

  useEffect(() => {
    scrollToTop();
    navContext.resetNextBtn();
    navContext.resetOnNavigateBack();
    navContext.setFooterNavVisible(true);
    navContext.setNextButtonVisible(false);
    navContext.setBackButtonVisible(false);
    navContext.setSubtotalVisible(false);
  }, []);

  const onClickMoreDetails = () => {
    window.open(apiContext.finalDetailsSettings.promo_link, "_blank");
  };

  return (
    <div
      className={"screen screen-thank-you"}
    >
      <div className={"container"}>
        <div className="copy" dangerouslySetInnerHTML={{ __html: apiContext.finalDetailsSettings.kiosk_thank_you_copy }}></div>
        <div
          className={"section section-further-customise copy"}
          dangerouslySetInnerHTML={{
            __html:
              apiContext.finalDetailsSettings.further_customise_copy,
          }}
        />
        {apiContext.finalDetailsSettings.promo_enabled && (
          <div className={"section section-final-promo"}>
            {apiContext.finalDetailsSettings.promo_desktop_image && (
              <img
                className={"desktop"}
                src={apiContext.finalDetailsSettings.promo_desktop_image}
                alt={""}
              />
            )}
            {apiContext.finalDetailsSettings.promo_mobile_image && (
              <img
                className={"mobile"}
                src={apiContext.finalDetailsSettings.promo_mobile_image}
                alt={""}
              />
            )}

            {apiContext.finalDetailsSettings.promo_link !== "" && (
              <MoreDetailsBtn
                onClick={onClickMoreDetails}
                title={
                  apiContext.finalDetailsSettings.promo_link_text !== ""
                    ? apiContext.finalDetailsSettings.promo_link_text
                    : "More Details"
                }
              />
            )}
          </div>
        )}
      </div>
    </div>
  );
});

export default ThankYouScreen;
